import { Component, Input, OnInit, Renderer2 } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';
import { NotificationTextMessage } from '@app/core/Enum';
import { CommonService } from '@app/core/Services';
import { GetCountryList, CountryState, SaveAuditDetails } from '@app/core/Store';
import { Store } from '@ngxs/store';
import { tap } from 'rxjs/operators';

@Component({
  selector: 'app-add-audit-popup',
  templateUrl: './add-audit-popup.component.html',
  styleUrls: ['./add-audit-popup.component.scss']
})
export class AddAuditPopupComponent implements OnInit {
  @Input() accountingBodies: any[]
  contactDetailForm: FormGroup<any>;
  savePayload: any = {};
  renderer: Renderer2;
  accountingBody: any;
  countryList: any[];

  constructor(private commonService: CommonService, private store: Store,
  public dialogRef: MatDialogRef<AddAuditPopupComponent>) { }

  ngOnInit(): void {
    this.GetCountryListData();
    this.setForm();
  }

  setForm(): void{
    this.contactDetailForm = new FormGroup({
      name: new FormControl('', [Validators.required, this.commonService.whiteSpaceValidate]),
      lastName: new FormControl('', [Validators.required, this.commonService.whiteSpaceValidate]),
      country: new FormControl(''),
      county: new FormControl(''),
      address1: new FormControl(''),
      address2: new FormControl(''),
      city: new FormControl(''),
      postCode: new FormControl(''),
      firmName:new FormControl(''),
      accountingbody:new FormControl(''),
      selectedAccountingBody: new FormControl(''),
      dateAudited: new FormControl(''),
      rfirmname:new FormControl(''),
      firmLocation:new FormControl(''),
    });
  }

  GetCountryListData(): void {
    this.store
      .dispatch(new GetCountryList())
      .pipe(
        tap(() => {
          this.countryList = this.store.selectSnapshot(CountryState.getCountry);
          if (this.countryList.length > 0) {
            this.contactDetailForm.controls.country.setValue(this.countryList[205].id);
          }
        })
      )
      .subscribe();
  }

  onAccountingBodyChange(event: any): void{
    this.disableField();
  }

  disableField(): void{
    if(this.contactDetailForm.controls['selectedAccountingBody'].value === '0'){
      this.contactDetailForm.controls['accountingbody'].enable();
    } else {
      this.contactDetailForm.controls['accountingbody'].disable();
      this.contactDetailForm.controls.accountingbody.setValue('');
    }
  }

  onSave(): any{
    try{
      this.savePayload = {
        "id": '00000000-0000-0000-0000-000000000000',
        "name": this.contactDetailForm.controls['name'].value,
        "lastName": this.contactDetailForm.controls['lastName'].value,
        "address1": this.contactDetailForm.controls['address1'].value,
        "address2": this.contactDetailForm.controls['address2'].value,
        "city": this.contactDetailForm.controls['city'].value,
        "postCode": this.contactDetailForm.controls['postCode'].value,
        "country": this.contactDetailForm.controls['country'].value,
        "county": this.contactDetailForm.controls['county'].value,
        "isActive": true,
        "isDelete": true,
        "createdBy": '00000000-0000-0000-0000-000000000000',
        "updatedBy": '00000000-0000-0000-0000-000000000000',
        "updatedOn": null,
        "accountingbody": this.contactDetailForm.controls['selectedAccountingBody'].value === '0' ? this.contactDetailForm.controls['accountingbody'].value : this.contactDetailForm.controls['selectedAccountingBody'].value,
        "firmName": null,
        "rfirmname": null,
        "firmLocation": null,
        "ischeckedauditdetails": null,
        "isShowonreport": false
      }
    }catch (error) {
      this.commonService.onFailure(NotificationTextMessage.errorMessage);
      return false;
    }
    return true;
  }

  saveContactDetails(): void{
    if (this.contactDetailForm.invalid) {
      this.commonService.addValidation(this.contactDetailForm, this.renderer);
    } else if(this.onSave()){
      this.store.dispatch(new SaveAuditDetails(this.savePayload)).pipe().subscribe(
              (response: any) => {
                this.commonService.onSucess(NotificationTextMessage.successMessage);
               // this.getAllAudits();
              }
            );
      this.dialogRef.close(true);
    }
  }
}
